'use client';

import React from 'react';

const TechStackMarquee = () => {
  const tools = [
    'Make.com',
    'Zapier',
    'Python',
    'AWS',
    'OpenAI',
    'Airtable',
    'HubSpot',
    'Supabase',
    'PostgreSQL',
    'GoHighLevel'
  ];

  // Duplicate the array for seamless loop
  const duplicatedTools = [...tools, ...tools];

  return (
    <section data-component-id="src/app/homepage/components/TechStackMarquee.tsx:23:4" data-component-path="src/app/homepage/components/TechStackMarquee.tsx" data-component-line="23" data-component-end-line="75" data-component-file="TechStackMarquee.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-16%20overflow-hidden%22%7D" className="py-16 overflow-hidden">
      {/* Heading Block */}
      <div data-component-id="src/app/homepage/components/TechStackMarquee.tsx:25:6" data-component-path="src/app/homepage/components/TechStackMarquee.tsx" data-component-line="25" data-component-end-line="35" data-component-file="TechStackMarquee.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%20mb-16%22%7D" className="text-center mb-16">
        <p data-component-id="src/app/homepage/components/TechStackMarquee.tsx:26:8" data-component-path="src/app/homepage/components/TechStackMarquee.tsx" data-component-line="26" data-component-end-line="28" data-component-file="TechStackMarquee.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20font-semibold%20text-primary%20uppercase%20tracking-wider%20mb-4%22%2C%22textContent%22%3A%22OUR%20TECH%20STACK%20TOOLS%22%7D" className="text-sm font-semibold text-primary uppercase tracking-wider mb-4">
          OUR TECH STACK TOOLS
        </p>
        <h2 data-component-id="src/app/homepage/components/TechStackMarquee.tsx:29:8" data-component-path="src/app/homepage/components/TechStackMarquee.tsx" data-component-line="29" data-component-end-line="31" data-component-file="TechStackMarquee.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-2xl%20md%3Atext-3xl%20font-bold%20text-white%20mb-4%22%2C%22textContent%22%3A%22Powered%20by%20Modern%20Infrastructure%22%7D" className="text-2xl md:text-3xl font-bold text-white mb-4">
          Powered by Modern Infrastructure
        </h2>
        <p data-component-id="src/app/homepage/components/TechStackMarquee.tsx:32:8" data-component-path="src/app/homepage/components/TechStackMarquee.tsx" data-component-line="32" data-component-end-line="34" data-component-file="TechStackMarquee.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-lg%20text-muted-foreground%20max-w-3xl%20mx-auto%22%2C%22textContent%22%3A%22We%20deploy%20code-native%20tools%20you%20own.%20No%20rip-and-replace.%20We%20integrate%20and%20systemize%20your%20existing%20stack.%22%7D" className="text-lg text-muted-foreground max-w-3xl mx-auto">
          We deploy code-native tools you own. No rip-and-replace. We integrate and systemize your existing stack.
        </p>
      </div>

      {/* Marquee Container - No background, no borders */}
      <div data-component-id="src/app/homepage/components/TechStackMarquee.tsx:38:6" data-component-path="src/app/homepage/components/TechStackMarquee.tsx" data-component-line="38" data-component-end-line="63" data-component-file="TechStackMarquee.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%22%7D" className="relative">
        {/* Scrolling Content */}
        <div data-component-id="src/app/homepage/components/TechStackMarquee.tsx:40:8" data-component-path="src/app/homepage/components/TechStackMarquee.tsx" data-component-line="40" data-component-end-line="62" data-component-file="TechStackMarquee.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%22%7D" 
          className="flex"
          style={{
            animation: 'scroll 30s linear infinite',
            width: 'fit-content'
          }}
        >
          {duplicatedTools?.map((tool, index) => (
            <span data-component-id="src/app/homepage/components/TechStackMarquee.tsx:48:12" data-component-path="src/app/homepage/components/TechStackMarquee.tsx" data-component-line="48" data-component-end-line="60" data-component-file="TechStackMarquee.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22whitespace-nowrap%22%7D"
              key={`${tool}-${index}`}
              className="whitespace-nowrap"
              style={{
                fontFamily: "'Space Grotesk', monospace",
                fontWeight: 700,
                fontSize: '20px',
                color: '#64748b',
                marginRight: '80px'
              }}
            >
              {tool}
            </span>
          ))}
        </div>
      </div>
      {/* CSS Animation */}
      <style data-component-id="src/app/homepage/components/TechStackMarquee.tsx:65:6" data-component-path="src/app/homepage/components/TechStackMarquee.tsx" data-component-line="65" data-component-end-line="74" data-component-file="TechStackMarquee.tsx" data-component-name="style" data-component-content="%7B%22elementName%22%3A%22style%22%7D" jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
      `}</style>
    </section>
  );
};

export default TechStackMarquee;